export const LISTING_STATUS = {
  DRAFT: 1,
  APPRAISAL_PENDING: 2,
  APPRAISAL_READY: 3,
  APPRAISAL_REJECTED: 4,
  PENDING: 5,
  SELLER_APPROVAL_PENDING: 6,
  SELLER_APPROVAL_REJECTED: 7,
  READY: 8,
  LIVE: 9,
  SOLD: 10,
  PICKUP_PENDING: 11,
  PICKUP_BOOKED: 12,
  IN_TRANSIT: 13,
  DELIVERED: 14,
  CLOSED: 15,
  REJECTED: 16,
  RESERVED: 17,
  LIVE_NEW_VALUATION_PENDING: 18,
};

const ALL_LISTING_STATUS = [
  LISTING_STATUS.DRAFT,
  LISTING_STATUS.APPRAISAL_PENDING,
  LISTING_STATUS.APPRAISAL_READY,
  LISTING_STATUS.APPRAISAL_REJECTED,
  LISTING_STATUS.PENDING,
  LISTING_STATUS.SELLER_APPROVAL_PENDING,
  LISTING_STATUS.SELLER_APPROVAL_REJECTED,
  LISTING_STATUS.READY,
  LISTING_STATUS.LIVE,
  LISTING_STATUS.SOLD,
  LISTING_STATUS.PICKUP_PENDING,
  LISTING_STATUS.PICKUP_BOOKED,
  LISTING_STATUS.IN_TRANSIT,
  LISTING_STATUS.DELIVERED,
  LISTING_STATUS.CLOSED,
  LISTING_STATUS.REJECTED,
  LISTING_STATUS.RESERVED,
  LISTING_STATUS.LIVE_NEW_VALUATION_PENDING,
];

export const EDITABLE_LISTING_STATUSES = [LISTING_STATUS.DRAFT];

export const VIEWABLE_LISTING_STATUSES = [
  LISTING_STATUS.SELLER_APPROVAL_PENDING,
  LISTING_STATUS.SELLER_APPROVAL_REJECTED,
  LISTING_STATUS.READY,
  LISTING_STATUS.LIVE,
  LISTING_STATUS.SOLD,
  LISTING_STATUS.PICKUP_PENDING,
  LISTING_STATUS.PICKUP_BOOKED,
  LISTING_STATUS.IN_TRANSIT,
  LISTING_STATUS.DELIVERED,
  LISTING_STATUS.CLOSED,
  LISTING_STATUS.REJECTED,
  LISTING_STATUS.RESERVED,
];

export function ListingStatusToLabel(status) {
  switch (status) {
    case LISTING_STATUS.DRAFT:
      return 'Draft';
    case LISTING_STATUS.APPRAISAL_PENDING:
      return 'Valuation Pending';
    case LISTING_STATUS.APPRAISAL_READY:
      return 'Valuation Ready';
    case LISTING_STATUS.APPRAISAL_REJECTED:
      return 'Valuation Revised';
    case LISTING_STATUS.PENDING:
      return 'Pending';
    case LISTING_STATUS.SELLER_APPROVAL_PENDING:
      return 'Approval Pending';
    case LISTING_STATUS.SELLER_APPROVAL_REJECTED:
      return 'Approval Rejected';
    case LISTING_STATUS.READY:
      return 'Ready';
    case LISTING_STATUS.LIVE:
      return 'Live';
    case LISTING_STATUS.SOLD:
      return 'Sold';
    case LISTING_STATUS.PICKUP_PENDING:
      return 'Pickup Pending';
    case LISTING_STATUS.PICKUP_BOOKED:
      return 'Pickup Booked';
    case LISTING_STATUS.IN_TRANSIT:
      return 'In Transit';
    case LISTING_STATUS.DELIVERED:
      return 'Delivered';
    case LISTING_STATUS.CLOSED:
      return 'Closed';
    case LISTING_STATUS.REJECTED:
      return 'Declined';
    case LISTING_STATUS.RESERVED:
      return 'Reserved';
    case LISTING_STATUS.LIVE_NEW_VALUATION_PENDING:
      return 'Live - New Valuation';
    default:
      return 'Unrecognized Status';
  }
}

export default LISTING_STATUS;
